import { AppContainer, ShowTotal } from "../../../Components/Global/Reusable";
import React from "react";
import DialogModal from "../../../Components/DialogModal";
import StyledTable from "../../../Components/Table";
import { UpdateRow } from "../../../features/ShopsReportSlice";
import BodyData from "./BodyData";
import Details from "./Details";
import Labels from "./Labels";
import BlockModal from "../../../Components/BlockModal";
import ImageModal from "../../../Components/DialogModal/ImageModal";
import { Toast } from "../../../Components/Toast";
import { TABLES } from "../../../enums/tables";
import { useShopsReport } from "./hooks/useShopsReport";

export default function Index() {
  const {
    data,
    setData,
    Id,
    details,
    preview,
    setPreview,
    filteredDataLength,
    setFilteredDataLength,
    isToastOpen,
    toastMessage,
    secondaryFilter,
    orderFilter,
    setOrderFilter,
    dateFilter,
    setDateFilter,
    modalNameFilter,
    setModalNameFilter,
    modalItineraryFilter,
    setModalItineraryFilter,
    modalCategoryFilter,
    setModalCategoryFilter,
    modalCountryFilter,
    setModalCountryFilter,
    modalCityFilter,
    setModalCityFilter,
    OpenDetails,
    CloseDetails,
    toggleToast,
    onToastOpen,
    OpenModal,
  } = useShopsReport();

  return (
    <>
      <Toast
        variation={toastMessage.variation}
        title={toastMessage.title}
        open={isToastOpen}
        onOpenChange={toggleToast}
      />
      <AppContainer maxWidth="xl">
        <StyledTable
          TableTitle="Lojas"
          Component={<ShowTotal total={filteredDataLength} />}
          Labels={
            <Labels
              modalNameFilter={modalNameFilter}
              modalItineraryFilter={modalItineraryFilter}
              modalCategoryFilter={modalCategoryFilter}
              modalCountryFilter={modalCountryFilter}
              modalCityFilter={modalCityFilter}
              setModalNameFilter={setModalNameFilter}
              setModalItineraryFilter={setModalItineraryFilter}
              setModalCategoryFilter={setModalCategoryFilter}
              setModalCountryFilter={setModalCountryFilter}
              setModalCityFilter={setModalCityFilter}
              orderFilter={orderFilter}
              setOrderFilter={setOrderFilter}
              dateFilter={dateFilter}
              setDateFilter={setDateFilter}
            />
          }
          TableData={
            <BodyData
              modalNameFilter={modalNameFilter}
              modalItineraryFilter={modalItineraryFilter}
              modalCategoryFilter={modalCategoryFilter}
              modalCountryFilter={modalCountryFilter}
              modalCityFilter={modalCityFilter}
              setModalNameFilter={setModalNameFilter}
              setModalItineraryFilter={setModalItineraryFilter}
              setModalCategoryFilter={setModalCategoryFilter}
              setModalCountryFilter={setModalCountryFilter}
              setModalCityFilter={setModalCityFilter}
              secondaryFilter={secondaryFilter}
              orderFilter={orderFilter}
              OpenDetails={OpenDetails}
              OpenModal={OpenModal}
              dateFilter={dateFilter}
              setFilteredDataLength={setFilteredDataLength}
            />
          }
        />
        {details && (
          <Details
            CloseDetails={CloseDetails}
            detailsID={Id}
            openPreview={setPreview}
          />
        )}
        {data && (
          <DialogModal>
            <BlockModal
              onToastOpen={onToastOpen}
              data={data}
              setModal={setData}
              UpdateRow={UpdateRow}
              role="ConnectStore"
              collection={TABLES.CONNECTSTORES}
            />
          </DialogModal>
        )}
        {preview && (
          <DialogModal>
            <ImageModal openPreview={setPreview} image={preview} />
          </DialogModal>
        )}
      </AppContainer>
    </>
  );
}
